import MonthlySummaryError from './MonthlySummaryError';
class MonthlySummaryNumberLessThanOne extends MonthlySummaryError {
    numberOfBricks;
    constructor(numberOfBricks, options) {
        super('The number of bricks can not be less than one', options);
        this.numberOfBricks = numberOfBricks;
    }
}
export default MonthlySummaryNumberLessThanOne;
